import MockAdapter from "axios-mock-adapter";
import {
  LOGIN_URL,
  GET_USER_BY_ACCESSTOKEN_URL,
  REGISTER_URL,
  REQUEST_PASSWORD_URL,
} from "../redux/AuthCRUD";
import { UsersTableMock } from "./usersTableMock";

export function mockAuth(mock: MockAdapter) {
  mock.onPost(LOGIN_URL).reply(({ data }) => {
    const { email, password } = JSON.parse(data) as { email: string; password: string };

    if (email && password) {
      const user = UsersTableMock.table.find(
        (x) =>
          x.email.toLowerCase() === email.toLowerCase() &&
          x.password === password
      );

      if (user) {
        const auth = user.auth;
        // Return user data without password
        const { password: _, ...userWithoutPassword } = user;
        return [200, { ...auth, user: userWithoutPassword }];
      }
    }

    return [400];
  });

  mock.onPost(REGISTER_URL).reply(({ data }) => {
    const { email, firstname, lastname, password } = JSON.parse(data) as {
      email: string;
      firstname: string;
      lastname: string;
      password: string;
    };

    if (email && firstname && lastname && password) {
      const newUser = {
        uid: String(UsersTableMock.table.length + 1),
        id: String(UsersTableMock.table.length + 1),
        email,
        firstname,
        lastname,
        password, // Only stored in mock for testing
        roles: [2], // Manager
        auth: {
          accessToken: "access-token-" + Math.random(),
          refreshToken: "access-token-" + Math.random(),
        },
        pic: process.env.PUBLIC_URL + "/media/users/default.jpg",
      };

      UsersTableMock.table.push(newUser as typeof UsersTableMock.table[0]);
      const { password: _, ...userWithoutPassword } = newUser;

      return [200, { ...newUser.auth, user: userWithoutPassword }];
    }

    return [400];
  });

  mock.onPost(REQUEST_PASSWORD_URL).reply(({ data }) => {
    const { email } = JSON.parse(data) as { email: string };

    if (email) {
      const user = UsersTableMock.table.find(
        (x) => x.email.toLowerCase() === email.toLowerCase()
      );
      if (user) {
        // In a real app, this would send an email
        // Always return success to prevent user enumeration
        return [200, { result: true }];
      }
    }

    // Always return success to prevent user enumeration
    return [200, { result: true }];
  });

  mock
    .onGet(GET_USER_BY_ACCESSTOKEN_URL)
    .reply(({ headers }) => {
      const Authorization = headers?.Authorization as string | undefined;
      

      const accessToken =
        Authorization &&
        Authorization.startsWith("Bearer ") &&
        Authorization.slice("Bearer ".length);

      if (accessToken) {
        const user = UsersTableMock.table.find(
          (x) => x.auth?.accessToken === accessToken
        );

        if (user) {
          return [200, { ...user, password: undefined }];
        }
      }

      return [401];
    });

  // function generateUserId(): number {
  //   const ids = UsersTableMock.table.map((el) => el.id);
  //   const maxId = Math.max(...ids);
  //   return maxId + 1;
  // }
}
